/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-08 22:51:48
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/DeveloperSetting/CreateAccessModal/AddAccessTitle.tsx
 */
import React from 'react';
import Row from '@/src/components/Layouts/Row/Row';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Input from '@/src/components/Antd/Input/Input';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import TopContainer from '@/src/components/Antd/Modal/TopContainer';
import CountWords from '@/src/components/CountWords/CountWords';

const AddUnit = (props) => {
  const {
    setModal,
    onSubmit,
    title,
    maxLength = 50,
    cancelText,
    externalClose, //true在外部处理submit时的closeModal逻辑
    okText,
    defaultValue,
    nameList,
    currentData = [],
  } = props;
  const [unit, setUnit] = React.useState(defaultValue || '');
  const [err, setErr] = React.useState(false);
  const [help, setHelp] = React.useState('');
  const onChange = (e) => {
    setUnit(e);
    if (err) setErr(false);
    if (nameList && nameList.includes(e)) {
      setErr(true);
      setHelp('A ‘Access Key’ already exists with the same name.');
    } else {
      setHelp('');
    }
  };
  console.log(err, help, 'help');
  const onCancel = () => {
    if (setModal) setModal(false);
  };
  const onOk = () => {
    if (!unit || unit.match(/^\s*$/)) {
      setErr(true);
      return;
    }
    if (currentData.find((i) => i.name === unit)) {
      setErr(true);
      return;
    }
    if (onSubmit) onSubmit(unit);
    if (setModal && !externalClose) setModal(false);
  };
  return (
    <Row
      elements={[
        {
          child: (
            <React.Fragment>
              <TopContainer>
                <ItemWrapper
                  title={title}
                  rightPart={
                    <CountWords
                      count={(unit || '').length}
                      allCount={maxLength}
                    />
                  }>
                  <Input
                    help={help || 'Please fill the form且不能重复'}
                    error={err}
                    autoFocus
                    size='large'
                    value={unit}
                    onChange={onChange}
                    maxLength={maxLength}
                  />
                </ItemWrapper>
              </TopContainer>
              <ModalFooter
                onCancel={onCancel}
                cancelText={cancelText}
                okText={okText}
                hideOkButton={!unit || err}
                onOk={onOk}
              />
            </React.Fragment>
          ),
        },
      ]}
    />
  );
};
export default AddUnit;
